import styled from "styled-components"
import { SpaceProps, Space } from "antd"
import React from "react"

interface MainDivProps {
  showcolor: boolean
}

export const MainDiv: React.FunctionComponent<SpaceProps> = styled(Space)`
  width: 100%;
  padding: 15px;
  border-radius: 5px;
  margin: 10px 0;
  border: 1px solid orange;
`

export const HeaderDiv = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid black;
`

export const NestedHeaderDiv = styled.div`
  display: flex;
  padding-bottom: 10px;
  border-bottom: 1px solid black;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
`

export const NestedDivContent: React.FunctionComponent<SpaceProps> = styled(
  Space,
)`
  width: 100%;
  padding: 10px;
  border: 1px solid orange;
  margin: 10px 0;
`
